<div class="page">
  @if (pageSettings) {
    <div class="header">
      @if (pageSettings?.pageLogoUrl) {
        <img class="icon" [src]="pageSettings.pageLogoUrl" />
      }
      @if (pageSettings?.pageTitle) {
        <div class="title">
          {{ pageSettings.pageTitle }}
        </div>
      }
      @if (pageSettings?.shouldShowWebsiteButton) {
        <button mat-stroked-button color="primary" (click)="onButtonClick()">
          {{ pageSettings.buttonText }}
        </button>
      }
      @if (pagePosts?.length) {
        <i class="user-info-msg"> Click on the images below </i>
      }
    </div>
  }

  @if (pagePosts?.length) {
    <div class="container">
      <div class="gallery">
        @for (page of pagePosts; track page.postId) {
          <div class="gallery-item">
            <!-- Single image display (no carousel needed) -->
            @if (!page.isCarousel) {
              @if (page.isSingleVideo) {
                <!-- Single video: render inline without carousel -->
                <div class="video-container" (click)="onMediaClick(page, $event)">
                  <video
                    class="gallery-video"
                    autoplay
                    muted
                    playsinline
                    preload="metadata"
                    [attr.data-post-id]="page.postId"
                    (canplay)="onVideoCanPlay($event)"
                  >
                    <source
                      [src]="$safeNavigationMigration(page.displayMedia?.[0])"
                      [attr.type]="getMimeType(page, $safeNavigationMigration(page.displayMedia?.[0])) || null"
                    />
                    Your browser does not support the video tag.
                  </video>
                  @if (!isVideoPlaying(page.postId)) {
                    <div class="play-indicator" (click)="forcePlayVideo(page.postId, $event)">
                      <mat-icon>play_arrow</mat-icon>
                    </div>
                  }
                </div>
              } @else {
                <a [href]="page.permalink" target="_blank">
                  <img class="gallery-image" [src]="page.imageUrl" />
                </a>
              }
            } @else {
              <!-- Carousel display for multiple media or video -->
              <div class="media-carousel" [attr.data-post-id]="page.postId">
                <button
                  class="carousel-nav prev"
                  (click)="navigatePrev(page.postId); $event.stopPropagation()"
                  (touchstart)="$event.stopPropagation()"
                  [disabled]="getCurrentIndex(page.postId) === 0"
                >
                  <mat-icon>chevron_left</mat-icon>
                </button>

                <div class="carousel-content" (click)="onMediaClick(page, $event)">
                  @for (mediaUrl of page.displayMedia; track $index; let i = $index) {
                    <div
                      class="media-item"
                      [class.active]="i === getCurrentIndex(page.postId)"
                      [style.transform]="'translateX(' + -getCurrentIndex(page.postId) * 100 + '%)'"
                    >
                      @if (!page.isVideoByUrl?.[mediaUrl]) {
                        <img class="gallery-image" [src]="mediaUrl" (click)="onMediaClick(page, $event)" />
                      } @else {
                        <div class="video-container" (click)="onMediaClick(page, $event)">
                          <video
                            class="gallery-video"
                            autoplay
                            muted
                            playsinline
                            preload="metadata"
                            [attr.data-post-id]="page.postId"
                            (canplay)="onVideoCanPlay($event)"
                          >
                            <source
                              [src]="mediaUrl"
                              [attr.type]="page.resolvedMimeByUrl?.[mediaUrl] || getMimeType(page, mediaUrl) || null"
                            />
                            Your browser does not support the video tag.
                          </video>
                          @if (!isVideoPlaying(page.postId)) {
                            <div class="play-indicator" (click)="forcePlayVideo(page.postId, $event)">
                              <mat-icon>play_arrow</mat-icon>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>

                <button
                  class="carousel-nav next"
                  (click)="navigateNext(page.postId); $event.stopPropagation()"
                  (touchstart)="$event.stopPropagation()"
                  [disabled]="getCurrentIndex(page.postId) === getMediaUrls(page).length - 1"
                >
                  <mat-icon>chevron_right</mat-icon>
                </button>

                <!-- Indicator dots -->
                @if (page.displayMedia?.length > 1) {
                  <div class="carousel-indicators">
                    @for (mediaUrl of page.displayMedia; track $index; let i = $index) {
                      <button
                        class="indicator"
                        [class.active]="i === getCurrentIndex(page.postId)"
                        (click)="setCurrentIndex(page.postId, i); $event.stopPropagation()"
                        (touchstart)="$event.stopPropagation()"
                      ></button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <p class="empty-msg">{{ 'No images have been linked' }}</p>
  }
</div>
